import * as styles from './index.vanilla.css'

interface Props {
  url: string
  contentType: string
}

export const CurriculumViewer = ({ url, contentType }: Props) => {
  const isPdf = contentType === 'application/pdf'
  const isImage = contentType.startsWith('image/')
  const isVideo = contentType.startsWith('video/')

  return (
    <div>
      {isPdf && (
        <div className={styles.viewerWrapper}>
          <iframe src={`${url}#toolbar=0&navpanes=0&zoom=FitH`} className={styles.viewer} />
        </div>
      )}

      {isImage && <img src={url} className={styles.previewImage} />}

      {isVideo && (
        <video className={styles.previewVideo} controls>
          <source src={url} type={contentType} />
        </video>
      )}
    </div>
  )
}
